function StartupKindToString(startupKind) {
    switch (startupKind) {
        case 1 : return 'NewWindow';
        case 3 : return 'ReloadedWindow';
        case 4 : return 'ReopenedWindow';
    }
}
function LifecyclePhaseToString(phase) {
    switch (phase) {
        case 1 : return 'Starting';
        case 2 : return 'Ready';
        case 3 : return 'Restored';
        case 4 : return 'Eventually';
    }
}
export { LifecyclePhaseToString, StartupKindToString };
